import "./styles.css";
import Header from "./components/Header";
import SideBar from "./components/SiderBar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Agendamentos from "./pages/Agendamentos";
import Clientes from "./pages/Clientes";
import Colaboradores from "./pages/colaboradores";
import Login from "./pages/login";
import AdminDashboard from "./pages/AdminDashboard";
import Cadastro from "./pages/cadastro";
import Reserva from "./pages/reservaCarro";
import Servicos from "./pages/servicos";
import Horarios from "./pages/Horarios";
import CadastroCnhClient from "./pages/cnhCliente";
import CheckOut from "./pages/liveracao";
import CheckIn from "./pages/entrada";

import { useDispatch, useSelector } from "react-redux";
//  <Header/>
//<SideBar/>
//<Route path="/" exact element={<Agendamentos/>} />




const Routas = () => {
    const {  auth } = useSelector(
        (state) => state.cliente
      );


  return (
    <>
      <div className="container-fluid h-100">
        <div className="row h-100">
          <Router>
            <Routes>
              <Route path="/" exact element={<Login />} />     
              
              <Route path="/clientes" exact element={ <Clientes />} />
              <Route path="/clientes/cnh" exact element={ <CadastroCnhClient />} />
              <Route path="/colaboradores" exact element={ <Colaboradores />} />
              <Route path="/cadastro" exact element={<Cadastro />} />
              <Route path="/reserva" exact element={<Reserva />} />
              <Route path="/servico" exact element={<Servicos />} />
              <Route path="/horarios" exact element={<Horarios />} />
              <Route path="/admin" exact element={<AdminDashboard />} />
              <Route path="/admin/checkout" exact element={<CheckOut />} />
              <Route path="/admin/checkin" exact element={<CheckIn />} />
            </Routes>
          </Router>
        </div>
      </div>
    </>
  );
};

export default Routas;
